import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from "@mui/material";

const isJsonValid = (str) => {
	try {
		return JSON.parse(str) && !!str;
	} catch (e) {
		return false;
	}
};

const formatKey = (key) => {
	return key
		.replace(/([A-Z])/g, " $1")
		.replace(/_/g, " ")
		.replace(/^./, (str) => str.toUpperCase())
		.trim();
};

export default function EditSettingsDialog({ open, onClose, updateSettings, setUpdateSettings, updateSettingsHandler }) {
	const handleAddDay = () => {
		const newSettings = JSON.parse(updateSettings.settings);

		if (updateSettings.settingsType === 0) {
			const nextDay = newSettings.length + 1;
			newSettings.push({ day: nextDay.toString(), amount: "20" });

			setUpdateSettings({
				...updateSettings,
				settings: JSON.stringify(newSettings),
			});
		}
	};

	const handleInputChange = (e, key, nestedKey = null, itemIndex = null, nestedIndex = null, innerIndex = null) => {
		const { value } = e.target;
		const newSettings = JSON.parse(updateSettings.settings);

		if (nestedKey && nestedKey !== "day") {
			if (itemIndex !== null && nestedIndex !== null && innerIndex !== null) {
				newSettings[key][itemIndex][nestedKey][innerIndex][nestedKey] = value;
			} else {
				newSettings[key][nestedKey] = value;
			}
		} else if (!nestedKey) {
			newSettings[key] = value;
		}

		setUpdateSettings({
			...updateSettings,
			settings: JSON.stringify(newSettings),
		});
	};

	const renderSettingsFields = (settingsJson) => {
		return Object.entries(settingsJson).map(([key, value], index) => {
			if (typeof value !== "object") {
				return (
					<Grid item xs={12} key={index}>
						<TextField
							label={formatKey(key)}
							fullWidth
							value={value}
							variant="outlined"
							onChange={(e) => handleInputChange(e, key)}
							sx={{ borderRadius: 2, mb: 2 }}
						/>
					</Grid>
				);
			}

			if (typeof value === "object" && !Array.isArray(value)) {
				return (
					<Grid item xs={12} key={index}>
						<Grid container spacing={2}>
							{Object.entries(value).map(([nestedKey, nestedValue], nestedIndex) => (
								<Grid item xs={6} key={nestedIndex}>
									<TextField
										label={formatKey(nestedKey)}
										fullWidth
										value={nestedValue}
										variant="outlined"
										onChange={(e) => handleInputChange(e, key, nestedKey)}
										sx={{ borderRadius: 2, mb: 2 }}
										disabled={nestedKey === "day"}
									/>
								</Grid>
							))}
						</Grid>
					</Grid>
				);
			}

			if (Array.isArray(value)) {
				return (
					<Grid item xs={12} key={index}>
						<Typography variant="body1" sx={{ mb: 3, fontWeight: "bold" }}>
							{formatKey(key)}
						</Typography>
						<Grid container spacing={2}>
							{value.map((item, itemIndex) => (
								<Grid item xs={12} key={itemIndex}>
									<Grid container spacing={2}>
										{Object.entries(item).map(([nestedKey, nestedValue], nestedIndex) => {
											if (Array.isArray(nestedValue)) {
												return (
													<Grid item xs={12} key={nestedIndex}>
														<Grid container spacing={2}>
															{nestedValue.map((innerItem, innerIndex) => (
																<Grid item xs={12} key={innerIndex}>
																	<Typography variant="caption" sx={{ fontWeight: "bold" }}>
																		{formatKey(nestedKey)}
																	</Typography>
																	<Grid container spacing={2} marginTop={1}>
																		{Object.entries(innerItem).map(([innerKey, innerValue], innerFieldIndex) => (
																			<Grid item xs={4} key={innerFieldIndex}>
																				<TextField
																					label={formatKey(innerKey)}
																					fullWidth
																					variant="outlined"
																					value={innerValue}
																					onChange={(e) => handleInputChange(e, key, nestedKey, itemIndex, nestedIndex, innerIndex)}
																					sx={{
																						borderRadius: 2,
																						mb: 2,
																					}}
																				/>
																			</Grid>
																		))}
																	</Grid>
																</Grid>
															))}
														</Grid>
													</Grid>
												);
											}

											return (
												<Grid item xs={6} key={nestedIndex}>
													<TextField
														label={formatKey(nestedKey)}
														fullWidth
														variant="outlined"
														value={nestedValue}
														onChange={(e) => handleInputChange(e, key, nestedKey, itemIndex, nestedIndex)}
														sx={{
															borderRadius: 2,
														}}
														disabled={nestedKey === "day"}
													/>
												</Grid>
											);
										})}
									</Grid>
								</Grid>
							))}
						</Grid>
					</Grid>
				);
			}

			return null;
		});
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
			<DialogTitle>Edit Settings</DialogTitle>
			<DialogContent>
				<Grid container>
					<Grid item xs={12} sx={{ m: 0, p: 1 }}>
						{updateSettings.settings && isJsonValid(updateSettings.settings)
							? renderSettingsFields(JSON.parse(updateSettings.settings))
							: null}
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>

				<Button onClick={updateSettingsHandler} autoFocus disabled={!isJsonValid(updateSettings.settings)}>
					Edit
				</Button>
				{updateSettings.settingsType === 0 && (
					<Button onClick={handleAddDay} color="primary">
						Add Day
					</Button>
				)}
			</DialogActions>
		</Dialog>
	);
}
